import React, { useRef, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import BackgroundImage from "../components/BackgroundImage";
import ProductSelection from "../components/Steps/ProductSelection";
import ProductInstallation from "../components/Steps/ProductInstallation";
import ConfiguratorTitle from "../components/ConfiguratorTitle";
import ProgressBar from "../components/Progressbar";
import ProductDimensions from "../components/Steps/ProductDimensions";
import ProductColours from "../components/Steps/ProductColours";
import ProductLED from "../components/Steps/ProductLED";
import ProductAssembly from "../components/Steps/ProductAssembly";
import BranchSearch from "../components/Steps/BranchesSearch";
import PersonalDataForm from "../components/Steps/PersonalInformation";
import ConfirmationForm from "../components/ConfirmationForm";
import ThankYouMessage from "../components/ThankYouMessage";
import LoadingBar from "react-top-loading-bar";
import "react-toastify/dist/ReactToastify.css";
import ProductCovering from "../components/Steps/ProductCovering";

const MainConfigurator: React.FC = () => {
  const [postalCode, setPostalCode] = useState("");

  const [currentStep, setCurrentStep] = useState<number>(1);
  const [loading, setLoading] = useState(false);
  const loadingBarRef = useRef<any>(null);

  const [transitioning, setTransitioning] = useState(false);

  const [formData, setFormData] = useState({
    product: "",
    installationType: "",
    dimensions: { width: 0, depth: 0 },
    color: "",
    ledOption: "",
    postalCode: "",
    service: "",
    productCovering: "",
    selectedBranch: {
      postalCode: "",
      address: ""
    },
    personalDetails: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      address: "",
      postalCode: ""
    },
  });

  const [error, setError] = useState("");
  const [isSuccess, setSuccess] = useState(false);

  const handleInputChange = (key: string, value: any) => {
    setError("");
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));

    if (key == "selectedBranch") {
      return;
    }
    handleNext(true);
  };

  const handlePostalCode = (postalCode: string) => {
    setPostalCode(postalCode);
    updatePersonalDetails({ postalCode: postalCode })
  }

  const handleNext = (shouldSkip: boolean = false, showWeb: boolean = false) => {

    console.log("shouldSkip", shouldSkip);

    if (showWeb) {
      window.open("https://kd-ueberdachung.de/", "_self");
      return;
    }

    if (!shouldSkip) {
      const validationError = validateStep();
      if (validationError) {
        setError(validationError);
        return;
      }

      setError("");
    }

    if (currentStep === 10) {
      handleSubmit();
    } else {
      loadingBarRef.current.continuousStart();
      setTimeout(() => {
        setCurrentStep((prev) => prev + 1);
        loadingBarRef.current.complete();
      }, 500);
    }
  };

  const handleBack = () => {
    loadingBarRef.current.continuousStart();
    setTimeout(() => {
      setCurrentStep((prev) => Math.max(prev - 1, 1));
      loadingBarRef.current.complete();
    }, 500);
  };

  const handleSelectBranch = (branch: any) => {
    handleInputChange("selectedBranch", branch)
  }

  const handleSubmit = async () => {
    loadingBarRef.current?.continuousStart();
    setLoading(true);
    try {

      //https://konfiguration-backend-hwk1stq70-sadafs-projects-1d8b7d4f.vercel.app/api
      const API_PATH = "https://konfig-kd-ueberdachung.de/api"

      const response = await fetch(`${API_PATH}/webhook-proxy`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Webhook Error Response:", errorData);
        throw new Error(errorData.error || "Failed to submit the configuration.");
      }

      const result = await response.json();
      console.log("Webhook Response:", result);
      setSuccess(true);
      setCurrentStep((prev) => prev + 1);

      toast.success("Konfiguration erfolgreich übermittelt!", {
        position: "top-center",
        autoClose: 5000, // 5 seconds
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

    } catch (error) {
      console.error("Error submitting configuration:", error);

      setError("Ein Fehler ist beim Absenden der Konfiguration aufgetreten.");
    } finally {
      setTimeout(() => {
        setLoading(false);
        loadingBarRef.current?.complete();
      }, 500);
    }
  };


  const updateDimensions = (newDimensions: { width: number; depth: number }) => {
    setFormData((prev) => ({
      ...prev,
      ["dimensions"]: newDimensions,
    }));
  };

  const updatePersonalDetails = (updatedDetails: any) => {
    setFormData((prev) => ({
      ...prev,
      personalDetails: {
        ...prev.personalDetails,
        ...updatedDetails,
      },
    }));
  };

  const triggerTransition = (callback: () => void) => {
    setTransitioning(false);
    setTimeout(() => {
      callback();
      setTransitioning(false);
    }, 0);
  };

  const validateStep = () => {
    console.log("curentstep", currentStep);
    switch (currentStep) {
      case 1:
        if (!formData.product) return "Bitte wählen Sie ein Produkt aus.";
        break;
      case 2:
        if (!formData.installationType) return "Bitte wählen Sie eine Montageart aus.";
        break;
      case 3:
        if (!formData.productCovering) return "Bitte wählen Sie eine Eindeckung aus.";
        break;
      case 4:
        if (formData.dimensions.width === 0 || formData.dimensions.depth === 0)
          return "Bitte geben Sie gültige Maße ein.";
        break;
      case 5:
        if (!formData.color) return "Bitte wählen Sie eine Farbe aus.";
        break;
      case 6:
        if (!formData.ledOption) return "Bitte wählen Sie eine LED-Option aus.";
        break;
      case 7:
        if (!formData.service) return "Bitte wählen Sie eine Montageservice aus.";
        break;
      case 8:
        if (!formData.selectedBranch?.address) return "Bitte wählen Sie eine Filiale aus.";
        break;
      case 9:
        const { firstName, lastName, email, phone } = formData.personalDetails;
        if (!firstName || !lastName || !email || !phone)
          return "Bitte füllen Sie alle persönlichen Daten aus.";
        break;
      default:
        break;
    }
    return "";
  };

  const handleProductCoveringInputChange = (key: string, value: any) => {
    updateDimensions({ width: 0, depth: 0 });
    handleInputChange(key, value)
  }


  const renderStepContent = (currentStep: number, formData: any) => {
    switch (currentStep) {
      case 1:
        return (
          <>
            <ConfiguratorTitle title="Bitte wählen Sie das gewünschte Produkt aus:" />
            <ProductSelection
              selectedProduct={formData.product}
              onSelectProduct={(product) => handleInputChange("product", product)}
            />
          </>
        );
      case 2:
        return (
          <>
            <ConfiguratorTitle title="Welche Art der Montage bevorzugen Sie?" />
            <ProductInstallation
              selectedType={formData.installationType}
              onSelectType={(type) => handleInputChange("installationType", type)}
            />
          </>
        );
      case 3:
        return (
          <>
            <ConfiguratorTitle title="Wählen Sie Ihre gewünschte Eindeckung an?" />
            <ProductCovering
              selectedProduct={formData.productCovering}
              onSelectProduct={(product) => handleProductCoveringInputChange("productCovering", product)}
            />
          </>
        );
      case 4:
        return (
          <>
            <ConfiguratorTitle title="Welche Maße soll das Produkt haben?" />
            <ProductDimensions
              dimensions={formData?.dimensions}
              onUpdateDimensions={updateDimensions}
              productCovering={formData.productCovering}

            />
          </>
        );
      case 5:
        return (
          <>
            <ConfiguratorTitle title="Welche Farbe möchten Sie wählen?" />
            <ProductColours
              selected={formData.color}
              onSelect={(selected) => handleInputChange("color", selected)}
            />
          </>
        );
      case 6:
        return (
          <>
            <ConfiguratorTitle title="Möchten Sie LED-Beleuchtung hinzufügen?" />
            <ProductLED
              selected={formData.ledOption}
              onSelect={(selected) => handleInputChange("ledOption", selected)}
            />
          </>
        );
      case 7:
        return (
          <>
            <ConfiguratorTitle title="Möchten Sie einen Montageservice nutzen?" />
            <ProductAssembly
              selected={formData.service}
              onSelect={(selected) => handleInputChange("service", selected)}
            />
          </>
        );
      case 8:
        return (
          <>
            <ConfiguratorTitle title="Wählen Sie Ihre gewünschte Filiale aus:" />
            <BranchSearch
              onSelectBranch={handleSelectBranch}
              selectedBranch={formData?.selectedBranch}
              setPostalCode={handlePostalCode}
              postalCode={postalCode}
            />
          </>
        );
      case 9:
        return (
          <>
            <ConfiguratorTitle title="Überprüfung Ihre Angaben >" />
            <PersonalDataForm
              formData={formData.personalDetails}
              updateForm={updatePersonalDetails}
              handleNext={handleNext}
            />
          </>
        );
      case 10:
        return (
          <>
            <ConfiguratorTitle title="Möchten Sie Ihre Anfrage absenden?" />
            <ConfirmationForm form={formData} handleSubmit={handleSubmit}
            />
          </>
        );
      case 11:
        return (
          <>
            <ConfiguratorTitle title="Vielen Dank für Ihre Anfrage" />
            <ThankYouMessage formData={formData}
            />
          </>
        );
      default:
        return <p>Invalid Step</p>;
    }
  };

  console.log("formData.........", formData)

  return (
    <>
      <BackgroundImage />

      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
        className="relative w-full h-screen flex flex-col items-center overflow-y-auto  "
      >
        <LoadingBar color="#f11946" ref={loadingBarRef} shadow={true} height={6} />

        <Header
          logoMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/image_latest.png`}
          logoDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/logosite.svg`}
        />

        <div
          className={`bg-white w-[95%] mt-6 mb-3 md:w-[800px] h-[calc(100vh-300px)] rounded-[25px] shadow-lg px-2 sm:px-6 md:px-16 mt-4 md:mt-6 flex flex-col overflow-hidden transition-all duration-300 ${transitioning ? "opacity-0 scale-95" : "opacity-100 scale-100"
            }`}
        >
          <div className="flex-grow overflow-y-auto scrollbar-thin">
            {loading ? (
              <div className="flex justify-center items-center h-full">
                <div className="loader border-t-4 border-red-600 rounded-full w-12 h-12 animate-spin"></div>
              </div>
            ) : (
              <>
                <ProgressBar currentStep={currentStep - 1} totalSteps={9} />
                <div className="flex-grow">
                  {renderStepContent(currentStep, formData)}
                </div>
              </>
            )}
            {error && (
              <div className="text-red-600 font-bold text-center mt-2">
                {error ?? "Unknown ERROR MESSAGE"}
              </div>
            )}
          </div>
        </div>


        <Footer
          onNext={(showWeb) => { handleNext(false, showWeb) }}
          onBack={handleBack}
          showBackButton={currentStep > 1 && currentStep < 11}
          showNextButton={true}
          showWeb={currentStep === 11}
          showActive={Boolean(validateStep())}
        />
      </form>
      <ToastContainer />

    </>
  );
};

export default MainConfigurator;
